<div *ngIf="producer">
  <div class="alert-slidable alert alert-danger" [class.visible]="hasError">
    {{message}}
  </div>
</div>